import React, { Component } from 'react';
import './App.css';
import moment from 'moment';
import './moment-round';
import 'moment-timezone';

class App extends Component {
  now() {
    return new moment();
  }

  closestHour() {
    return this.now().round(1, 'hours');
  }

  allowedTimeZones() {
    return moment.tz
      .names()
      .filter(x => x.indexOf('/') !== -1)
      .filter(x => !x.startsWith('Etc'));
  }

  getTime(dateTime) {
    return moment({ h: dateTime.hours(), m: dateTime.minutes() });
  }

  timeZonesWhereFivePm() {
    const localtime = this.closestHour();
    const five = this.getTime(moment([2018, 5, 1, 17, 0, 0]));

    return this.allowedTimeZones().filter(zone =>
      this.getTime(localtime.tz(zone)).isSame(five)
    );
  }

  timeZoneName(tzName) {
    const parts = tzName.replace(/_/g, ' ', -1).split('/');
    return parts[parts.length - 1];
  }

  getRandomElement(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  timeZoneMap(tzName) {
    const parts = tzName.replace(/_/g, ' ', -1).split('/');
    return `${parts[parts.length - 1]}, ${parts[parts.length - 2]}`;
  }

  render() {
    const localTz = moment.tz.guess();
    const beforeOrAfter = this.closestHour().isSameOrBefore(this.now())
      ? " it's after 5pm in "
      : " it's almost 5pm in ";
    const timeZone = this.getRandomElement(this.timeZonesWhereFivePm());
    const mapLink = `https://maps.google.com/?q=${this.timeZoneMap(timeZone)}`;

    const is5pm = this.timeZonesWhereFivePm().includes(localTz);

    const not5pmText = (
      <div>
        {' '}
        <p className="App-intro">
          It&apos;s not 5pm in {this.timeZoneName(localTz)} time,
        </p>
        <p className="App-intro">but hey,</p>
        <p className="App-intro">
          {beforeOrAfter}
          <a href={mapLink}>{this.timeZoneName(timeZone)}</a>
        </p>
      </div>
    );

    const fivePmText = (
      <div>
        <p className="App-intro">
          Yes, {beforeOrAfter} {this.timeZoneName(localTz)} time!
        </p>
      </div>
    );

    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">Can I have a martini?</h1>
        </header>
        {is5pm ? fivePmText : not5pmText}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js